/**
 * Holds the initialized state of the util
 * @type {Boolean}
 */
var $ = window.$
var isInitialized = false,
  /**
   * Element to check the content property on
   * @type {Object}
   */
  $head = $('head'),
  /**
   * The name for the desktop breakpoint
   * @type {String}
   */
  deskBreakpoint = 'desktop',
  /**
   * The name for the tablet breakpoint
   * @type {String}
   */
  lapBreakpoint = 'tablet',
  /**
   * The name for the mobile breakpoint
   * @type {String}
   */
  palmBreakpoint = 'mobile',
  /**
   * List of available breakpoints as defined in the SCSS
   * @type {Array}
   */
  availableBreakpoints = [deskBreakpoint, lapBreakpoint, palmBreakpoint],
  /**
   * The css property to use as placeholder
   * @type {String}
   */
  cssProperty = 'font-family',
  /**
   * Default fallback breakpoint
   * @type {String}
   */
  fallbackBreakpoint = deskBreakpoint,
  /**
   * Current breakpoint
   * @type {String}
   */
  currentBreakpoint = '',
  /**
   * Used as references to the timer
   * and the delay in ms
   */
  resizeTimerDelay = 200,
  resizeTimer

/**
 * A helper function that makes removes quotes from a string
 * @param {String} string The string to strip quotes off
 */
function removeQuotes(string) {
  return string.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '')
}

/**
 * Update the breakpoint if a resize is finished
 * @function updateBreakpoint
 */
function updateBreakpoint() {
  // Reason we strip the quotes is because of browser returning
  // inconsistent values, some wrapped in quotes and some not
  var breakpoint = removeQuotes($head.css(cssProperty))

  setBreakpoint(breakpoint)
}

/**
 * Handle the resize event in a time queue to prevent overload
 * @function onResizeUpdateBreakpoint
 */
function onResizeUpdateBreakpoint() {
  if (resizeTimer) {
    clearTimeout(resizeTimer)
  }

  resizeTimer = setTimeout(updateBreakpoint, resizeTimerDelay)
}

/**
 * Check if the given breakpoint is valid
 * @param {String} breakpoint The name of the breakpoint
 * @function validateBreakpoint
 */
function validateBreakpoint(breakpoint) {
  if (breakpoint && availableBreakpoints.join(',').indexOf(breakpoint) !== -1) {
    return true
  }

  return false
}

/**
 * Get the current breakpoint
 * @function getBreakpoint
 */
function getBreakpoint() {
  return currentBreakpoint
}

/**
 * Set the breakpoint to a the given value
 * @param {String} breakpoint The name of the breakpoint
 * @function setBreakpoint
 */
function setBreakpoint(breakpoint) {
  var oldBreakpoint = currentBreakpoint

  currentBreakpoint = validateBreakpoint(breakpoint)
    ? breakpoint
    : fallbackBreakpoint

  // Make sure we only trigger the event after resize, not on init
  if (oldBreakpoint !== currentBreakpoint && isInitialized === true) {
    $(window).trigger('breakpointChange', [currentBreakpoint, oldBreakpoint])
  }
}

/**
 * Initialize the util
 * @function init
 */
function init() {
  $(window).on('resize', onResizeUpdateBreakpoint)

  updateBreakpoint()

  // Mark the util as initialized
  isInitialized = true
}

// Initialize the utility
init()

// export {removeQuotes, updateBreakpoint, onResizeUpdateBreakpoint, validateBreakpoint, getBreakpoint, setBreakpoint}
export { getBreakpoint }
